import React, { useEffect } from 'react';
import { Box, Center, Heading, Image, Text } from '@chakra-ui/react';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';

import { CenteredLoader } from 'clipsal-cortex-ui/src/components/CenteredLoader';

import { useReduxDispatch } from '../../../app/store';
import chargerOfflineImg from '../../../assets/images/evse_charger_station_offline.svg';
import chargerOnlineImg from '../../../assets/images/evse_charger_station_online.svg';
import chargerOfflineRingImg from '../../../assets/images/evse_charger_status_offline.svg';
import chargerOnlineRingImg from '../../../assets/images/evse_charger_status_online.svg';
import { SlidingAnimationPageBase } from '../../../common/components/SlidingAnimationPageBase';
import { useParamBackUrl } from '../../../common/hooks/use-param-back-url';
import { fetchEvChargerDetails, selectEvChargerData } from '../dashboard/evChargerSlice';
import { isEvChargerOffline } from '../ev-charger-helper';
import { ScheduleList } from './ScheduleList';

/* istanbul ignore next -- @preserve */
export function DeviceChargingSchedule() {
  const { t } = useTranslation();
  const backURL = useParamBackUrl('../device-status');
  const { status, hasFetchedEvChargerDetails, siteDeviceId } = useSelector(selectEvChargerData);
  const dispatch = useReduxDispatch();

  // Status is kept live by the SSE stream owned at the EVChargerHome parent route, so the
  // offline gating below stays current without this page opening its own stream.
  const isChargerOffline = isEvChargerOffline(status);

  useEffect(() => {
    if (!hasFetchedEvChargerDetails && siteDeviceId) {
      dispatch(fetchEvChargerDetails(siteDeviceId));
    }
  }, [hasFetchedEvChargerDetails, siteDeviceId, dispatch]);

  return (
    <SlidingAnimationPageBase title={t('EVSE.edit schedule')} backURL={backURL} includeTopNavHamButton={true}>
      {!hasFetchedEvChargerDetails ? (
        <CenteredLoader text={`${t('Common.loading')}...`} />
      ) : (
        <Center flexDirection="column" px={3}>
          <Box position="relative" w="48vw" h="48vw" mb={4}>
            <Image
              w="100%"
              h="100%"
              src={isChargerOffline ? chargerOfflineRingImg : chargerOnlineRingImg}
              alt="Charger Status"
            />
            <Image
              src={isChargerOffline ? chargerOfflineImg : chargerOnlineImg}
              alt="Charging Schedule"
              h="62%"
              position="absolute"
              top="50%"
              left="50%"
              transform="translate(-50%, -50%)"
            />
          </Box>

          <Heading mt={2}>{t('EVSE.charging schedule')}</Heading>
          <Text textAlign="center" mt={1}>
            {isChargerOffline ? t('EVSE.schedule offline text') : t('EVSE.schedule text')}
          </Text>

          <ScheduleList />
        </Center>
      )}
    </SlidingAnimationPageBase>
  );
}
